import {
	AccordionIcon,
	AlignCenterIcon,
	AlignLeftIcon,
	AlignRightIcon,
	AppsIcon,
	AppsListIcon,
	ArchiveIcon,
	ArrowLeftIcon,
	ArrowRightIcon,
	ArrowsHorizontalIcon,
	ArrowsVerticalIcon,
	BackspaceIcon,
	BagIcon,
	BarcodeIcon,
	BoldIcon,
	BoxPackedIcon,
	BoxUnpackedIcon,
	BriefcaseIcon,
	BrowserIcon,
	BrowserSearchIcon,
	CalculatorIcon,
	CalendarDaysIcon,
	CalendarIcon,
	CameraIcon,
	CashIcon,
	CashierIcon,
	ChatDotsIcon,
	CheckCircleIcon,
	CheckIcon,
	ChevronDownIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ChevronUpIcon,
	ChristIcon,
	ClockIcon,
	CloseIcon,
	CodeIcon,
	CogIcon,
	ColorPaletteIcon,
	CopyIcon,
	CreditCardIcon,
	DesktopIcon,
	DiscountCircleIcon,
	DisketteIcon,
	DownloadIcon,
	DragDotsIcon,
	DragIcon,
	DrinkIcon,
	DropIcon,
	DrumsIcon,
	DuplicateIcon,
	EcosystemIcon,
	EditIcon,
	EllipsisIcon,
	ExclamationCircleIcon,
	ExclamationTriangleIcon,
	ExternalLinkIcon,
	EyeIcon,
	EyeOffIcon,
	FileAltIcon,
	FileIcon,
	FingerprintIcon,
	FireIcon,
	FlagIcon,
	FontIcon,
	ForbiddenIcon,
	GenerativeStarsIcon,
	GiftBoxIcon,
	GiftCardIcon,
	GlassesIcon,
	GlobeIcon,
	GoogleIcon,
	GuitarIcon,
	HeartIcon,
	HistoryIcon,
	HomeIcon,
	IdCardIcon,
	InfiniteIcon,
	InfoCircleIcon,
	InvoiceIcon,
	ItalicIcon,
	LifeRingIcon,
	LightbulbIcon,
	LinkIcon,
	LinkOffIcon,
	ListIcon,
	LocationIcon,
	LockIcon,
	LockOpenIcon,
	LogOutIcon,
	MagicWandIcon,
	MailIcon,
	MarketingIcon,
	MateIcon,
	MenuIcon,
	MetaIcon,
	MobileIcon,
	MoneyIcon,
	MoonIcon,
	NotificationIcon,
	ObeliskIcon,
	OnlineStoreIcon,
	OrderedListIcon,
	PaperPlaneIcon,
	PencilIcon,
	PesoIcon,
	PictureIcon,
	PixIcon,
	PlanetIcon,
	PlayIcon,
	PlusCircleIcon,
	PrinterIcon,
	PyramidIcon,
	QrCodeIcon,
	QuestionCircleIcon,
	RealIcon,
	RedoIcon,
	RemoveFormatIcon,
	RepeatIcon,
	RocketIcon,
	ScooterIcon,
	SearchIcon,
	ShareIcon,
	ShoppingCartIcon,
	ShotIcon,
	SizeHeightIcon,
	SizeWidthIcon,
	SlidersIcon,
	StarIcon,
	StatsIcon,
	StepsIcon,
	StickyNoteIcon,
	StopIcon,
	StoreIcon,
	SubcategoryIcon,
	SunIcon,
	TagIcon,
	TelephoneIcon,
	TextSizeIcon,
	TiendanubeIcon,
	TiktokIcon,
	ToolsIcon,
	TransferPesoIcon,
	TransferRealIcon,
	TrashIcon,
	TruckIcon,
	UndoIcon,
	UniversityIcon,
	UploadIcon,
	UserCircleIcon,
	UserGroupIcon,
	UserIcon,
	VerticalStacksIcon,
	VolumeIcon,
	WalletIcon,
	WhatsappIcon,
} from "@nimbus-ds/icons";
import type { NubeComponentIconName } from "@tiendanube/nube-sdk-types";

export type IconComponentProps = {
	color?: string;
	width?: number | string;
	height?: number | string;
};

export const iconMap: Record<
	NubeComponentIconName,
	React.ComponentType<IconComponentProps>
> = {
	infinite: InfiniteIcon,
	peso: PesoIcon,
	pix: PixIcon,
	accordion: AccordionIcon,
	"align-center": AlignCenterIcon,
	"align-left": AlignLeftIcon,
	"align-right": AlignRightIcon,
	"apps-list": AppsListIcon,
	apps: AppsIcon,
	archive: ArchiveIcon,
	"arrow-left": ArrowLeftIcon,
	"arrow-right": ArrowRightIcon,
	"arrows-horizontal": ArrowsHorizontalIcon,
	"arrows-vertical": ArrowsVerticalIcon,
	backspace: BackspaceIcon,
	bag: BagIcon,
	barcode: BarcodeIcon,
	bold: BoldIcon,
	"box-packed": BoxPackedIcon,
	"box-unpacked": BoxUnpackedIcon,
	briefcase: BriefcaseIcon,
	"browser-search": BrowserSearchIcon,
	browser: BrowserIcon,
	calculator: CalculatorIcon,
	"calendar-days": CalendarDaysIcon,
	calendar: CalendarIcon,
	camera: CameraIcon,
	cash: CashIcon,
	cashier: CashierIcon,
	"chat-dots": ChatDotsIcon,
	"check-circle": CheckCircleIcon,
	check: CheckIcon,
	"chevron-down": ChevronDownIcon,
	"chevron-left": ChevronLeftIcon,
	"chevron-right": ChevronRightIcon,
	"chevron-up": ChevronUpIcon,
	christ: ChristIcon,
	clock: ClockIcon,
	close: CloseIcon,
	code: CodeIcon,
	cog: CogIcon,
	"color-palette": ColorPaletteIcon,
	copy: CopyIcon,
	"credit-card": CreditCardIcon,
	desktop: DesktopIcon,
	"discount-circle": DiscountCircleIcon,
	diskette: DisketteIcon,
	download: DownloadIcon,
	"drag-dots": DragDotsIcon,
	drag: DragIcon,
	drink: DrinkIcon,
	drop: DropIcon,
	drums: DrumsIcon,
	duplicate: DuplicateIcon,
	ecosystem: EcosystemIcon,
	edit: EditIcon,
	ellipsis: EllipsisIcon,
	"exclamation-circle": ExclamationCircleIcon,
	"exclamation-triangle": ExclamationTriangleIcon,
	"external-link": ExternalLinkIcon,
	"eye-off": EyeOffIcon,
	eye: EyeIcon,
	"file-alt": FileAltIcon,
	file: FileIcon,
	fingerprint: FingerprintIcon,
	fire: FireIcon,
	flag: FlagIcon,
	font: FontIcon,
	forbidden: ForbiddenIcon,
	"generative-stars": GenerativeStarsIcon,
	"gift-box": GiftBoxIcon,
	"gift-card": GiftCardIcon,
	glasses: GlassesIcon,
	globe: GlobeIcon,
	google: GoogleIcon,
	guitar: GuitarIcon,
	heart: HeartIcon,
	history: HistoryIcon,
	home: HomeIcon,
	"id-card": IdCardIcon,
	"info-circle": InfoCircleIcon,
	invoice: InvoiceIcon,
	italic: ItalicIcon,
	"life-ring": LifeRingIcon,
	lightbulb: LightbulbIcon,
	"link-off": LinkOffIcon,
	link: LinkIcon,
	list: ListIcon,
	location: LocationIcon,
	"lock-open": LockOpenIcon,
	lock: LockIcon,
	"log-out": LogOutIcon,
	"magic-wand": MagicWandIcon,
	mail: MailIcon,
	marketing: MarketingIcon,
	mate: MateIcon,
	menu: MenuIcon,
	meta: MetaIcon,
	mobile: MobileIcon,
	money: MoneyIcon,
	moon: MoonIcon,
	notification: NotificationIcon,
	obelisk: ObeliskIcon,
	"online-store": OnlineStoreIcon,
	"ordered-list": OrderedListIcon,
	"paper-plane": PaperPlaneIcon,
	pencil: PencilIcon,
	picture: PictureIcon,
	planet: PlanetIcon,
	play: PlayIcon,
	"plus-circle": PlusCircleIcon,
	printer: PrinterIcon,
	pyramid: PyramidIcon,
	"qr-code": QrCodeIcon,
	"question-circle": QuestionCircleIcon,
	real: RealIcon,
	redo: RedoIcon,
	"remove-format": RemoveFormatIcon,
	repeat: RepeatIcon,
	rocket: RocketIcon,
	scooter: ScooterIcon,
	search: SearchIcon,
	share: ShareIcon,
	"shopping-cart": ShoppingCartIcon,
	shot: ShotIcon,
	"size-height": SizeHeightIcon,
	"size-width": SizeWidthIcon,
	sliders: SlidersIcon,
	star: StarIcon,
	stats: StatsIcon,
	steps: StepsIcon,
	"sticky-note": StickyNoteIcon,
	stop: StopIcon,
	store: StoreIcon,
	subcategory: SubcategoryIcon,
	sun: SunIcon,
	tag: TagIcon,
	telephone: TelephoneIcon,
	"text-size": TextSizeIcon,
	tiendanube: TiendanubeIcon,
	tiktok: TiktokIcon,
	tools: ToolsIcon,
	"transfer-peso": TransferPesoIcon,
	"transfer-real": TransferRealIcon,
	trash: TrashIcon,
	truck: TruckIcon,
	undo: UndoIcon,
	university: UniversityIcon,
	upload: UploadIcon,
	"user-circle": UserCircleIcon,
	"user-group": UserGroupIcon,
	user: UserIcon,
	"vertical-stacks": VerticalStacksIcon,
	volume: VolumeIcon,
	wallet: WalletIcon,
	whatsapp: WhatsappIcon,
};
